import { useContext } from 'react';
import { OptimizelyContext } from '@optimizely/react-sdk';

export function useOptimizely() {
  const { optimizely } = useContext(OptimizelyContext);
  return optimizely;
}
